import { useContext, useMemo } from "react";
import { UserContext } from "../../context/UserContext";

/**
 * Antes este hook hacía su PROPIO fetch a /v1/users/me en cada montaje, en
 * paralelo al que ya hace UserContext — sin caché ni cancelación. Cada vez
 * que el router pasaba de /login a una ruta privada (o viceversa),
 * PrivateRoutes se montaba de cero y disparaba otro fetch más, compitiendo
 * con los que ya estaban en vuelo. Con el backend algo lento eso podía dejar
 * al router rebotando entre /login y /dashboard sin asentarse nunca (reporte:
 * "se queda atrapada entre login y dashboard", con el backend a ~90% CPU
 * sostenido por la avalancha de peticiones repetidas).
 *
 * Ahora este hook no pide nada: solo lee el resultado de la única llamada a
 * /v1/users/me que ya hace UserContext (fuente única de verdad de la sesión).
 */
const useUserTokenPrivileges = () => {
  const [token, , , , , , , accessPrivileges, , , , venueType, , , , , , , , , userReady] = useContext(UserContext);

  // `user` solo existe cuando la sesión del token ACTUAL está resuelta. El rol del
  // contexto sobrevive al logout hasta que llega el /v1/users/me del token nuevo: si
  // se derivara sin esperar, Login navegaría con el rol de la cuenta anterior
  // (superadmin sale, staff entra en la misma tablet → /my_shops → /login → …).
  // useMemo: un literal nuevo por render re-disparaba el efecto de redirección de Login.
  const user = useMemo(
    () => (userReady && accessPrivileges ? { access_privileges: accessPrivileges, venue: { venue_type: venueType } } : null),
    [userReady, accessPrivileges, venueType]
  );

  return {
    token,
    user,
    accessPrivileges,
    venueType,
    isLoading: !!token && !userReady,
  };
};

export default useUserTokenPrivileges;
